import { Component, Prop, State, Host, Watch, h } from '@stencil/core';
import { getSvgContent } from './requests';
import { IconSize } from './types';
@Component({
  tag: 'fuel-icon',
  styleUrl: 'icon.scss',
  shadow: true,
})
export class FuelIcon {
  @State() svg: string;

  private static svgCache: { [key: string]: string | Promise<string> } = {};

  /**
   * Determines which icon should be rendered.
   * It must be the same as the filename.
   */
  @Prop() name: string;
  /**
   * Determines what size the icon should be.
   * If not declared it will inherit its size from
   * the parent element's font-size.
   */
  @Prop() size: IconSize;
  /**  Determines the style of the icon */
  @Prop() iconStyle: 'outlined' | 'filled' = 'outlined';

  @Watch('name')
  @Watch('iconStyle')
  watchPropHandler() {
    this.loadIcon();
  }

  getClassMap(): { [className: string]: boolean } {
    return {
      'icon': true,
      'icon--micro': this.size === 'micro',
      'icon--tiny': this.size === 'tiny',
      'icon--small': this.size === 'small',
      'icon--medium': this.size === 'medium',
      'icon--large': this.size === 'large',
      'icon--huge': this.size === 'huge',
      'icon--giant': this.size === 'giant',
    };
  }

  async loadIcon() {
    if (!this.name) return;

    const cacheKey = `${this.iconStyle}/${this.name}.svg`;
    const basePath = '/svg/icons';

    if (!FuelIcon.svgCache[cacheKey]) {
      FuelIcon.svgCache[cacheKey] = getSvgContent(`${basePath}/${cacheKey}`)
        .then(svg => {
          if (svg.ok && svg.content) {
            return svg.content;
          }
          return '';
        })
        .catch(err => {
          console.error(`Failed to load icon ${cacheKey}:`, err);
          delete FuelIcon.svgCache[cacheKey];
          return '';
        });
    }

    this.svg = await FuelIcon.svgCache[cacheKey];
  }

  connectedCallback() {
    this.loadIcon();
  }

  render() {
    return (
      <Host role="img" aria-label={this.name}>
        <div innerHTML={this.svg} class={this.getClassMap()}></div>
      </Host>
    );
  }
}
